import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import CheckAccountStatus from "./components/CheckAccountStatus";
import CheckConfirmation from "./components/CheckConfirmation";
import ConfirmAccount from "./components/ConfirmAccount";
import ConfirmEmail from "./components/ConfirmEmail";
import Home from "./components/Home";
import Login from "./components/Login";
import MySafeWindow from "./components/MySafeWindow";
import MyTests from "./components/MyTests";
import PageNotFound from "./components/PageNotFound";
import People from "./components/People";
import Following from "./components/Following";
import Follower from "./components/Follower";
import AddPublisher from "./components/AddPublisher";
import Registration from "./components/Registration";
import RequestPasswordChange from "./components/RequestPasswordChange";
import ResetPassword from "./components/ResetPassword";
import TestDetail from "./components/TestDetail";
import Settings from "./components/Settings";
import PersonalInfo from "./components/PersonalInfo";
import Welcome from "./components/Welcome";
import YourInfo from "./components/YourInfo";
import { Constants, Paths } from "./Constants";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <div style={{ height: "100%" }}>
      <BrowserRouter basename={Constants.BASE_NAME}>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route
            path={"/consumer/confirmemail"}
            exact
            component={ConfirmEmail}
          />
          <Route
            path={"/consumer/requestpasswordchange"}
            exact
            component={RequestPasswordChange}
          />
          <Route
            path={"/consumer/resetpassword"}
            exact
            component={ResetPassword}
          />

          <Route path={Paths.CONFIRM_EMAIL} exact component={ConfirmEmail} />
          <Route path={Paths.CONFIRM_ACCOUNT} exact component={ConfirmAccount} />
          <Route
            path={Paths.REQUEST_PASSWORD_CHANGE}
            exact
            component={RequestPasswordChange}
          />
          <Route path={Paths.RESET_PASSWORD} exact component={ResetPassword} />
          <Route path={Paths.LOGIN} exact component={Login} />
          <Route path={Paths.REGISTRATION} exact component={Registration} />
          <ProtectedRoute path={Paths.WELCOME} exact component={Welcome} />
          <ProtectedRoute path={Paths.YOUR_INFO} exact component={YourInfo} />
          <Route
            path={Paths.CHECK_CONFIRMATION}
            exact
            component={CheckConfirmation}
          />
          <ProtectedRoute
            path={Paths.CHECK_ACCOUNT_STATUS}
            exact
            component={CheckAccountStatus}
          />
          <ProtectedRoute
            path={Paths.SAFE_WINDOW}
            exact
            component={MySafeWindow}
          />
          <ProtectedRoute path={Paths.MY_TESTS} exact component={MyTests} />
          <ProtectedRoute
            path={Paths.TEST_DETAIL}
            exact
            component={TestDetail}
          />
          <ProtectedRoute path={Paths.PEOPLE} exact component={People} />
          <ProtectedRoute path={Paths.FOLLOWING} exact component={Following} />
          <ProtectedRoute path={Paths.FOLLOWER} exact component={Follower} />
          <ProtectedRoute
            path={Paths.ADD_PUBLISHER}
            exact
            component={AddPublisher}
          />
          <ProtectedRoute path={Paths.SETTINGS} exact component={Settings} />
          <ProtectedRoute
            path={Paths.PERSONAL_INFO}
            exact
            component={PersonalInfo}
          />
          <Route path="*" exact component={PageNotFound} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
